<div class="custom-attr-root">
    <div class="custom-attr-header">
        <div class="custom-attr-title">Custom Attributes</div>
        <button class="filledBtnStyle" (click)="addAttrBtnClick()">Add Attribute</button>
    </div>

    <div *ngIf="attributes.length > 0" class="attr-list">
        <div *ngFor="let att of attributes; let k = index" class="attr-item" [hidden]="!att.isActive">
            <div class="attr-item-header">
                <label class="attr-name">{{ att.attributeName }}</label>
                <button type="button" class="icon-btn" (click)="deleteAttribute(k)" aria-label="Delete attribute">
                    <mat-icon class="ftIcon bluecolor">delete</mat-icon>
                </button>
            </div>
            <input
                type="text"
                class="attr-input"
                [ngModel]="att.attributeValue"
                (ngModelChange)="att.attributeValue = $event; onValueChange()"
            />
        </div>
    </div>

    <div *ngIf="showAttributeInputs" class="add-attr-form">
        <div class="form-field">
            <label for="attributeName">Attribute Name</label>
            <input id="attributeName" type="text" [(ngModel)]="attributeName" />
        </div>

        <div class="form-field">
            <label for="attributeValue">Attribute Value</label>
            <input id="attributeValue" type="text" [(ngModel)]="attributeValue" />
        </div>

        <div class="form-actions">
            <button class="filledBtnStyle action-btn" (click)="addAttribute(0)">Add</button>
            <button class="filledBtnStyle action-btn secondary-btn" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>

